import {serviceAddress} from 'src/shared/user/selectors';
import {AUTH} from 'src/shared/auth/actions';
import {channelLineup} from 'src/shared/config/urls';
import {createFetchResourceAction} from 'src/shared/utils/resource';
import {LOAD_USER_COMPLETE} from 'src/shared/user/actions';

export const READ_CHANNEL_LINEUP_START = 'READ_CHANNEL_LINEUP_START';
export const READ_CHANNEL_LINEUP_SUCCESS = 'READ_CHANNEL_LINEUP_SUCCESS';
export const READ_CHANNEL_LINEUP_ERROR = 'READ_CHANNEL_LINEUP_ERROR';
export const READ_CHANNEL_LINEUP_COMPLETE = 'READ_CHANNEL_LINEUP_COMPLETE';

const getAddress = serviceAddress => `${serviceAddress.address.trim()}, ${serviceAddress.city.trim()}, ${serviceAddress.state}, ${serviceAddress.zipcode}`;

export const readChannelLineupUrl = params =>
  state =>
    channelLineup(state, params ? {...params} : {address: getAddress(serviceAddress(state))});

export const readChannelLineup = params => createFetchResourceAction({
  start: READ_CHANNEL_LINEUP_START,
  success: READ_CHANNEL_LINEUP_SUCCESS,
  error: READ_CHANNEL_LINEUP_ERROR,
  complete: READ_CHANNEL_LINEUP_COMPLETE,
  waitUntil: [AUTH, LOAD_USER_COMPLETE],
  url: readChannelLineupUrl(params),
  fetchOptions: {headers: {
    'Content-Type': 'application/json',
  }},
});
